import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  ENSURE_NETWORK_BUNDLE_TOPUPS,
  INITIAL_AUTHENTICATION,
  LOAD_NETWORK_BUNDLE_TOPUPS,
} from '../../actions/actionTypes';
import { Action, PromiseAction } from '../../actions/commonActions';
import {
  loadNetworkBundleTopupsFailure,
  loadNetworkBundleTopupsPending,
  loadNetworkBundleTopupsSuccess,
} from '../../actions/tariffActions';
import * as simProvisionApi from '../../api/simProvisionApi';
import { DropdownItem } from '../../components/ui/input/DropdownInput';
import { DropdownItemsState } from '../../models/state/simProvision/simProvisionState';
import { selectBundleTopups } from '../../selectors/simProvision';

/*
 * A saga which fetches the list of network bundle top-ups
 */
export function* loadNetworkBundleTopupsSaga(action: PromiseAction<number, DropdownItem[]>) {
  const networkId = action.payload;
  if (!networkId) {
    return;
  }

  yield put(loadNetworkBundleTopupsPending(networkId));
  try {
    const topups: DropdownItem[] = yield call(simProvisionApi.getBundleTopups, networkId);
    yield put(loadNetworkBundleTopupsSuccess(networkId, topups));
    action.resolve && action.resolve(topups);
  } catch (error: any) {
    yield put(loadNetworkBundleTopupsFailure(networkId, error));
    console.error(error);
  }
}

/*
 * A saga which fetches the network top-ups if needed
 */
export function* ensureNetworkBundleTopupsSaga(action: Action<number>) {
  const networkId = action.payload;
  if (!networkId) {
    return;
  }

  const tariffsState: DropdownItemsState = yield select(selectBundleTopups);
  const tariff = tariffsState[networkId];
  if (tariff) {
    const { expiresOn, isLoading } = tariff;
    if (isLoading || (expiresOn && expiresOn > new Date())) {
      return;
    }
  }

  yield call(loadNetworkBundleTopupsSaga, action);
}

/*
 * Initializes all sagas that are related to network bundle topup sizes.
 */
export function* initNetworkBundleTopupSagas() {
  yield take(INITIAL_AUTHENTICATION);
  yield takeEvery(ENSURE_NETWORK_BUNDLE_TOPUPS, ensureNetworkBundleTopupsSaga);
  yield takeEvery(LOAD_NETWORK_BUNDLE_TOPUPS, loadNetworkBundleTopupsSaga);
}
